var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position-relative" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-screen",
              attrs: { "fill-height": "", "justify-content-center": "" },
            },
            [
              _c("v-progress-circular", {
                staticClass: "loading",
                attrs: { indeterminate: "", color: "green" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isNotConfirm
        ? _c(
            "v-card",
            { staticClass: "user-question-dialog" },
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(
                  _vm._s(
                    !_vm.hasAsked
                      ? "質問を作成する"
                      : "質問ありがとうございました"
                  )
                ),
              ]),
              _vm._v(" "),
              !_vm.hasAsked
                ? _c(
                    "v-card-text",
                    [
                      _vm.invalidTitle
                        ? _c(
                            "p",
                            { staticClass: "text-sm-body-2 red--text mb-2" },
                            [_vm._v("タイトルを入力してください")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invalidBody
                        ? _c(
                            "p",
                            { staticClass: "text-sm-body-2 red--text mb-2" },
                            [_vm._v("内容を入力してください")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: { label: "質問のタイトル", required: "" },
                        model: {
                          value: _vm.title,
                          callback: function ($$v) {
                            _vm.title = $$v
                          },
                          expression: " title ",
                        },
                      }),
                      _vm._v(" "),
                      _c("Simplemde", {
                        attrs: { name: "question-list", rows: 3 },
                        model: {
                          value: _vm.body,
                          callback: function ($$v) {
                            _vm.body = $$v
                          },
                          expression: " body ",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _vm.user && _vm.user.hasActiveSubscription
                            ? _c(
                                "v-col",
                                { attrs: { lg: "12" } },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "my-0",
                                    attrs: {
                                      label:
                                        "プライベート質問 ＊この質問は一般には公開されません",
                                      "true-value": "private_question",
                                      "false-value": "nomal_question",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.questionType,
                                      callback: function ($$v) {
                                        _vm.questionType = $$v
                                      },
                                      expression: " questionType ",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-file-input", {
                                attrs: {
                                  label: "素材をアップロード",
                                  multiple: "",
                                  "prepend-icon": "mdi-paperclip",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (ref) {
                                        var text = ref.text
                                        return [
                                          _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                small: "",
                                                label: "",
                                                color: "primary",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(text) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  239836000
                                ),
                                model: {
                                  value: _vm.materials,
                                  callback: function ($$v) {
                                    _vm.materials = $$v
                                  },
                                  expression: " materials ",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  !_vm.confirmed
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "green", dark: "" },
                          on: { click: _vm.changeToConfirm },
                        },
                        [_vm._v("\n        質問を投稿する\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.confirmed
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "green darken-1", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.vModel = false
                            },
                          },
                        },
                        [_vm._v("キャンセル\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "v-card",
            { staticClass: "user-question-dialog" },
            [
              !_vm.hasAsked
                ? _c(
                    "v-card-text",
                    [
                      _vm.invalidTitle
                        ? _c(
                            "p",
                            { staticClass: "text-sm-body-2 red--text mb-2" },
                            [_vm._v("タイトルを入力してください")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invalidBody
                        ? _c(
                            "p",
                            { staticClass: "text-sm-body-2 red--text mb-2" },
                            [_vm._v("内容を入力してください")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-card-title", { staticClass: "headline" }, [
                        _vm._v(_vm._s(_vm.title)),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _c("div", {
                          staticClass: "mb-4 html-body",
                          domProps: {
                            innerHTML: _vm._s(_vm.markdownParser(_vm.body)),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _vm.user && _vm.user.hasActiveSubscription
                              ? _c(
                                  "v-col",
                                  { attrs: { lg: "12" } },
                                  [
                                    _c("v-checkbox", {
                                      staticClass: "my-0",
                                      attrs: {
                                        label:
                                          "プライベート質問 ＊この質問は一般には公開されません",
                                        "true-value": "private_question",
                                        "false-value": "nomal_question",
                                        "hide-details": "",
                                      },
                                      model: {
                                        value: _vm.questionType,
                                        callback: function ($$v) {
                                          _vm.questionType = $$v
                                        },
                                        expression: " questionType ",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _vm.materials.length > 0
                                  ? _c("div", [_vm._v("素材をアップロード")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.materials, function (material) {
                                  return _c("v-col", { key: material.name }, [
                                    _c("span", [_vm._v(_vm._s(material.name))]),
                                  ])
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c(
                              "v-col",
                              { staticClass: "p-0", attrs: { cols: "12" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "float-right d-flex" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "me-2",
                                        attrs: { cols: "2" },
                                      },
                                      [
                                        _vm.user && _vm.user.image
                                          ? _c("img", {
                                              staticStyle: { width: "40px" },
                                              attrs: {
                                                src: _vm.user.image.url,
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-col", [
                                      _vm.user
                                        ? _c("div", [
                                            _vm._v(_vm._s(_vm.user.name)),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "grey--text" }, [
                                        _vm._v(
                                          _vm._s(_vm.currentTime) +
                                            "に質問します。"
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "question-btn" },
                [
                  !_vm.hasAsked
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "green", dark: "" },
                          on: { click: _vm.createQuestion },
                        },
                        [_vm._v("\n        質問を投稿する\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hasAsked
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "green darken-1", text: "" },
                          on: { click: _vm.backToForm },
                        },
                        [_vm._v("修正する\n      ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasAsked
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "green darken-1", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.vModel = false
                            },
                          },
                        },
                        [_vm._v("OK\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }